import * as React from "react";
import { IReportDefinitionsService, ReportDefinition, ComponentType, MultiplicityType } from "@sa/rep-core";
import { ReportingProvider } from "@sa/rep-react";
import { ServiceProvider } from "@sa/rep-services-provider";
import { MapAPIService } from "./services/MapAPIService";
import { MapOLAPService } from "./services/MapOLAPService";
import { registerDataExtractorsProvider, registerExportQueryBuildersProvider } from "./data";
import { MapDefaultMarkService } from "./services/MapDefaultMarkService";
import { MapStore } from "./store/MapStore";
import { dataService, dictionaryService } from "../reportng/dataFlow";
import { Subscription } from "rxjs";

const API_URL = process.env.REACT_APP_API_URL || "/api";
const REPORTING_V2_API_URL = process.env.REACT_APP_REPORTING_V2_API_URL || "/api-reportng-v2";

const serviceProvider = new ServiceProvider();

export const ServiceProviderContext = React.createContext(serviceProvider);

export enum ServicesMaps {
  MapAPI = "MapAPI",
  MapStore = "MapStore",
  Dictionaries = "Dictionaries",
  DefaultMark = "DefaultMark",
  OLAP = "OLAP",
  MapOLAP = "MapOLAP",
  MapDataExtractorsProvider = "MapDataExtractorsProvider",
  MapExportQueryBuilderProvider = "MapExportQueryBuilderProvider",
}

serviceProvider.singleton(ServicesMaps.MapAPI, new MapAPIService(`${API_URL}/maps`, `${REPORTING_V2_API_URL}/maps`));
serviceProvider.singleton(ServicesMaps.Dictionaries, dictionaryService);
serviceProvider.singleton(ServicesMaps.MapStore, new MapStore(serviceProvider));
serviceProvider.singleton(ServicesMaps.OLAP, dataService);
registerDataExtractorsProvider(serviceProvider);
registerExportQueryBuildersProvider(serviceProvider);

const defaultMarkService = new MapDefaultMarkService(serviceProvider);
serviceProvider.singleton(ServicesMaps.DefaultMark, defaultMarkService);
const mapOLAPService = new MapOLAPService(serviceProvider);
serviceProvider.singleton(ServicesMaps.MapOLAP, mapOLAPService);

type MapReportingProviderProps = {
  useOLAPService?: boolean;
};

export const MapReportingProvider: React.FC<MapReportingProviderProps> = React.memo(({ children, useOLAPService = true }) => {
  React.useEffect(() => {
    const subscriptionDefaultMark = defaultMarkService.subscribe();
    let subscriptionMapOLAP: Subscription;

    if (useOLAPService) {
      subscriptionMapOLAP = mapOLAPService.subscribe();
    }
    return () => {
      subscriptionDefaultMark.unsubscribe();
      subscriptionMapOLAP?.unsubscribe();
    };
  }, []);
  return <ServiceProviderContext.Provider value={serviceProvider}>{children}</ServiceProviderContext.Provider>;
});
